import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const sellStatusApi = createAsyncThunk(
  "sellStatus",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/sellList", { params });
    return response.data;
  }
);

const sellStatusSlice = createSlice({
  name: "sellStatus",
  initialState: {
    sellStatus: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sellStatusApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sellStatusApi.fulfilled, (state, action) => {
        state.sellStatus = action.payload;
        state.loading = false;
      })
      .addCase(sellStatusApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sellStatusSlice.reducer;
